// extracted by mini-css-extract-plugin
module.exports = {"addCategoryScreen":"AddCategoryScreen_addCategoryScreen__2xNcU","addCategoryHeading":"AddCategoryScreen_addCategoryHeading__XFYHK"};